import React from 'react';
import { useParams, Navigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PageSeo } from '../seo/PageSeo';
import { breadcrumbSchema } from '../seo/schemas';
import { CommonMessages } from '../../i18n/Common.messages';
import { IntegrationsMessages, IntegrationsText } from './IntegrationsIndexPage.messages';
import { findIntegration } from './integrations';
import { Footer } from '../homepage/Footer';
import '../pages/static-page.css';

export const IntegrationDetailPage: React.FC = () => {
  const { t } = useTranslation();
  const { slug } = useParams<{ slug: string }>();
  if (!slug) return <Navigate to="/integrations" replace />;
  const integration = findIntegration(slug);
  if (!integration) return <Navigate to="/integrations" replace />;
  const fm = integration.module.frontmatter;
  const Content = integration.module.default;

  return (
    <>
      <PageSeo
        path={`/integrations/${slug}`}
        titleKey={fm.title}
        descriptionKey={fm.description}
        ogImage={fm.ogImage || '/og/og-default.png'}
        jsonLd={[
          breadcrumbSchema([
            { name: t(CommonMessages.BREADCRUMB_HOME), path: '/' },
            { name: t(IntegrationsMessages.BREADCRUMB, { defaultValue: IntegrationsText.BREADCRUMB }), path: '/integrations' },
            { name: fm.framework, path: `/integrations/${slug}` },
          ]),
        ]}
      />
      <article className="page-wrapper">
        <div className="static-page" style={{ paddingTop: '40px' }}>
          <nav style={{ fontSize: 14, color: 'var(--text-secondary)', marginBottom: 16 }}>
            <Link to="/integrations" style={{ color: 'var(--link-color)', textDecoration: 'none' }}>
              ← All integrations
            </Link>
          </nav>
          <h1>{fm.title}</h1>
          <Content />
        </div>
        <Footer />
      </article>
    </>
  );
};
